module.exports = __webpack_public_path__ + "Simple-Line-Icons.b2892aa62b0fb2c21c8d.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/vendor/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.2.2
// module id = ../../../../../src/assets/vendor/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.2.2
// module chunks = styles